module.exports = __webpack_public_path__ + "static/media/0347_Small.aa616f86.jpg";